// StatsCard.tsx — 3-up stats card for AccountPage profile section.

const F = '"Inter Variable","Inter",system-ui,sans-serif';
const DISPLAY = '"Fraunces Variable","Fraunces",Georgia,serif';

interface Stat {
  label: string;
  value: string;
  icon: string;
  sub?: string;
}

interface StatsCardProps {
  stats: Stat[];
}

export function StatsCard({ stats }: StatsCardProps) {
  return (
    <div style={{
      background: '#131C30',
      borderRadius: 24,
      border: '1px solid rgba(255,255,255,0.07)',
      padding: '24px 28px',
      display: 'grid',
      gridTemplateColumns: `repeat(${stats.length}, 1fr)`,
      gap: 0,
    }}>
      {stats.map((stat, i) => (
        <div
          key={stat.label}
          style={{
            textAlign: 'center',
            padding: '0 16px',
            borderRight: i < stats.length - 1 ? '1px solid rgba(255,255,255,0.07)' : 'none',
          }}
        >
          <div style={{ fontSize: 28, marginBottom: 8, lineHeight: 1 }}>{stat.icon}</div>
          <div style={{
            fontFamily: DISPLAY,
            fontSize: 36,
            fontWeight: 500,
            color: '#F4F3F0',
            letterSpacing: -0.02,
            lineHeight: 1,
          }}>{stat.value}</div>
          <div style={{
            fontFamily: F,
            fontSize: 12,
            color: '#8C98B0',
            marginTop: 6,
            fontWeight: 600,
            letterSpacing: 0.8,
            textTransform: 'uppercase',
          }}>{stat.label}</div>
          {stat.sub && (
            <div style={{
              fontFamily: F,
              fontSize: 11,
              color: '#4E5E78',
              marginTop: 4,
            }}>{stat.sub}</div>
          )}
        </div>
      ))}
    </div>
  );
}
